<template>
  <v-app>
    <div id="register">
      <div class="top-container">
        <img
          class="one-inventory-blue"
          src="@/assets/one-inventory-blue.png"
          alt
          @click="redirectToLogin"
        />
      </div>
      <div class="content">
        <div class="text">
          <p>{{ $t("_REGISTER.WELCOME") }}</p>
          <p v-if="state != 4">{{ $t("_REGISTER.SOLOGAN") }}</p>
        </div>
        <div class="steps">
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 1" />
            <div v-if="state <= 1" class="circle" :class="{ active: state == 1 }"></div>
            <span :class="{ active: state == 1 }">
              {{
              $t("_REGISTER.PERSONAL_DETAIL")
              }}
            </span>
          </div>
          <hr />
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 2" />
            <div v-if="state <= 2" class="circle" :class="{ active: state == 2 }"></div>
            <span :class="{ active: state == 2 }">
              {{
              $t("_REGISTER.HOTEL_DETAIL")
              }}
            </span>
          </div>
          <hr />
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 3" />
            <div v-if="state <= 3" class="circle" :class="{ active: state == 3 }"></div>
            <span :class="{ active: state == 3 }">
              {{
              $t("_REGISTER.CREATE_ACCOUNT")
              }}
            </span>
          </div>
        </div>
        <!-- end steps -->

        <!-- personal details -->
        <personal-detail v-if="state == 1" @validate="validate" ref="personalComponent" />
        <!-- end personal details -->

        <!-- hotel details -->
        <hotel-detail v-if="state == 2" @validate="validate" ref="hotelComponent" />
        <!-- end hotel details -->

        <!-- create account -->
        <create-account
          v-if="state == 3"
          @validate="validate"
          ref="createAccountComponent"
          :isAvailableRegis.sync="isAvailableRegis"
        />
        <!-- end create account -->

        <!-- final -->
        <final v-if="state == 4" />
        <!-- end final -->
        <v-container class="bottom">
          <v-row v-if="state != 4" class="p-0">
            <v-col sm="3" class="p-0">
              <span v-if="state != 4">* {{ $t("_REGISTER.REQUIRED_FIELD") }}</span>
            </v-col>
            <v-col sm="3" style="text-align:center"></v-col>
            <v-col sm="6" style="text-align: right" class="px-0">
              <button v-if="state != 1 && state != 4" class="mr-2 btn" @click="prevStep">
                <font-awesome-icon icon="arrow-left" />
                {{
                $t("_REGISTER.BACK")
                }}
              </button>
              <button v-if="isAvailableRegis && state == 3" class="btn register" @click="nextStep">
                {{ $t("_REGISTER.REGISTER") }}
                <font-awesome-icon icon="arrow-right" />
              </button>
              <button
                v-else-if="state != 4"
                :disabled="state == 3"
                class="btn btn-next"
                @click="nextStep"
              >
                {{ $t("_REGISTER.NEXT") }}
                <font-awesome-icon icon="arrow-right" />
              </button>
            </v-col>
          </v-row>
          <v-row v-else class="d-flex justify-center">
            <button class="btn btn-register-complete" @click="redirectToLogin" disabled>
              {{ $t("_REGISTER.COMPLETE_AND_LOGIN") }}
              <font-awesome-icon icon="check" class="mr-0"/>
            </button>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-app>
</template>

<script>
import PersonalDetail from "../../components/Register/PersonalDetail.vue";
import HotelDetail from "../../components/Register/HotelDetail.vue";
import CreateAccount from "../../components/Register/CreateAccount.vue";
import Final from "../../components/Register/Final.vue";
export default {
  components: {
    "personal-detail": PersonalDetail,
    "hotel-detail": HotelDetail,
    "create-account": CreateAccount,
    final: Final
  },
  data() {
    return {
      state: 1,
      isAvailableRegis: false
    };
  },
  methods: {
    validate() {
      this.state += 1;
      document.querySelector(".btn-next").disabled = true;
      document.querySelector(".btn-next").classList.remove("btn-indigo");
    },
    nextStep() {
      switch (this.state) {
        case 1:
          this.$refs.personalComponent.validate();
          break;
        case 2:
          this.$refs.hotelComponent.validate();
          break;
        case 3:
          this.$refs.createAccountComponent.save();
          break;
      }
    },
    prevStep() {
      this.state -= 1;
    },
    redirectToLogin() {
      location.href = "login";
    }
  }
};
</script>
